export default {"src":"/_next/static/media/logoMedicineBlack.d5db13d0.svg","height":73,"width":520,"blurWidth":0,"blurHeight":0};